import { Button, Center, Stack, Text } from '@chakra-ui/react'
import { useMutation } from 'src/hooks/use-mutation'
import { createApiClient } from 'src/lib/api-client'
import { setDatadogRUMUser } from 'src/lib/monitoring/monitoring'

type Props = {
  trialUid: string
  trialPatientUid: string
  onSignIn: () => void
}

export const PatientVideoCallSignIn: React.FC<Props> = ({
  trialUid,
  trialPatientUid,
  onSignIn,
}) => {
  const signInApi = createApiClient({
    path: '/trials/{trial_uid}/trial_patients/{trial_patient_uid}/signin_patient',
    httpMethod: 'post',
    params: {
      paths: {
        trial_uid: trialUid,
        trial_patient_uid: trialPatientUid,
      },
    },
  })

  const { request: signIn } = useMutation(signInApi.request, {
    onSuccess: () => {
      setDatadogRUMUser({
        id: trialPatientUid,
        trialPatientUid: trialPatientUid,
        trialUid: trialUid,
        role: 'Patient',
      })
      onSignIn()
    },
  })

  return (
    <Center h="100vh" w="100vw">
      <Stack spacing="8">
        <Text fontWeight="bold">医療機関とのビデオ通話を開始します</Text>
        <Center>
          <Button
            onClick={async () => {
              await signIn()
            }}
          >
            ビデオ通話を開始する
          </Button>
        </Center>
      </Stack>
    </Center>
  )
}
